import styled, { css } from 'styled-components';

export const ModalContainer = styled.div`
  background: rgba(0, 0, 0, 0.5);
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  transition: all 0.3s ease;
  // z-index: 2;
  padding-bottom: 100px;
`;

export const ModalBodyContent = styled.div<{
  open: boolean;
  transformOrigin?: { clientX: number; clientY: number };
  animation?: 'slide-left' | 'zoom-in';
  secondary?: boolean;
}>`
  display: flex;
  position: absolute;
  top: ${({ secondary }) => (secondary ? '13%' : '10%')};
  left: ${({ secondary }) => (secondary ? '12%' : '10%')};
  bottom: 0;
  right: ${({ secondary }) => (secondary ? '12%' : '10%')};
  transform: ${({ open }) => (open ? 'scale(1)' : 'scale(0)')};
  transform-origin: ${({ transformOrigin }) =>
    transformOrigin ? `${transformOrigin.clientX}px ${transformOrigin.clientY}px` : 'center'};
  transition: all 0.5s ease-in-out;

  ${({ animation, open }) =>
    animation &&
    animation === 'slide-left' &&
    css`
      transform: ${open ? `translateY(0)` : `translateY(-100%)`};
    `}
`;

export const ModalImageWrap = styled.div`
  img {
    width: 100%;
    height: 100vh;
    background-cover: cover;
    background-position: center;
    background-repeat: no-repeat;
    filter: opacity(0.4);
  }
`;

export const ModalBodyContentLeft = styled.div<{
  secondary?: boolean;
}>`
  background: #fff;
  // height: 100vh;
  overflow-y: auto;
  width: ${({ secondary }) => (secondary ? '100%' : '65%')};
  z-index: 5;
  // padding-bottom: 80px;
`;

export const ModalBodyContentRight = styled.div`
  background: #efefef;
  padding: 50px 0px;
  width: 35%;
  height: 100%;
`;

export const ModalCloseBtn = styled.div`
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 20px;
  height: 20px;
  position: absolute;
  top: 20px;
  right: 30px;
  z-index: 5;

  // &:hover {
  //   background: ${({ theme }) => theme.colors.primary};
  // }
`;
export const PrimaryModalLeftContainer = styled.div`
  position: relative;
  width: 100%;
`;
export const PrimaryModalRightContainer = styled.div`
  position: relative;
  width: 30%;
  flex-direction: column;
  display: flex;
  padding: 30px;
  gap: 20px;
  justify-content: center;
`;
export const HStack = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const HeaderImageWrapper = styled.div`
  position: relative;
`;

export const LoadingWrap = styled.div`
  overflow: hidden;
`;
